module.exports.lancelots = {
  vi: {
    title: 'Lancelot trong Avalon: đổi phe và luật Nhiệm vụ',
    description:
      'Khi nào Lancelot đổi phe trong Avalon? Tìm hiểu bộ năm thẻ của nền tảng, việc rút thẻ sau Nhiệm vụ 2, thẻ Nhiệm vụ bắt buộc và thông tin của Guinevere.',
    keywords: ['Lancelot', 'Vai trò', 'Luật chơi', 'Mẹo chơi'],
  },
  pt: {
    title: 'Lancelot em Avalon: troca de lado e regras das missões',
    description:
      'Quando Lancelot troca de lado em Avalon? Regras da plataforma: baralho de cinco cartas, trocas após a missão 2 e cartas de missão obrigatórias.',
    keywords: ['Lancelots', 'Papel', 'Regras', 'Dicas'],
  },
  en: {
    title: 'Lancelot in Avalon: Switching Sides & Mission Rules',
    description:
      'When does Lancelot switch sides in Avalon? Learn this platform’s five-card deck, draws after mission 2, forced mission cards and Guinevere’s information.',
    keywords: ['Lancelots', 'Role', 'Rules', 'Tips'],
  },
  ru: {
    title: 'Ланселоты в Авалоне: смена сторон и правила миссий',
    description:
      'Когда Ланселот меняет сторону в Авалоне? Колода из пяти карт, смены после второй миссии, обязательные карты похода и знания Гвиневры.',
    keywords: ['Ланселоты', 'Роль', 'Правила', 'Советы'],
  },
  'zh-TW': {
    title: '阿瓦隆蘭斯洛特：換邊規則與任務玩法',
    description: '阿瓦隆蘭斯洛特何時換邊？了解本站五張陣營牌、第二次任務後的抽牌、必須出的任務牌，以及女皇知道的資訊。',
    keywords: ['蘭斯洛特', '角色', '規則', '建議'],
  },
  'zh-CN': {
    title: '阿瓦隆兰斯洛特：换边规则与任务玩法',
    description: '阿瓦隆兰斯洛特何时换边？了解本站五张阵营牌、第二次任务后的抽牌、必须出的任务牌，以及女皇知道的信息。',
    keywords: ['兰斯洛特', '角色', '规则', '建议'],
  },
  es: {
    title: 'Lancelot en Avalon: cambios de bando y misiones',
    description:
      '¿Cuándo cambia Lancelot de bando en Avalon? Reglas de esta plataforma: mazo de cinco cartas, cambios tras la misión 2 y cartas de misión obligatorias.',
    keywords: ['Lancelots', 'Rol', 'Reglas', 'Consejos'],
  },
};
